import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FaFileContract, FaSpinner, FaArrowLeft } from 'react-icons/fa';
import LandingHeader from '../Components/LandingHeader';
import Footer from '../Components/Footer';
import HttpInterceptor from '../lib/HttpInterceptor';

function TermsOfService() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const fromConsent = searchParams.get('from') === 'consent';
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        setLoading(true);
        const response = await HttpInterceptor.get('/api/legal/terms_of_service', {
          showErrorToast: false,
        });
        setDocument(response.data.data);
        setError(null);
      } catch (err) {
        setError('Failed to load Terms of Service');
        console.error('Error fetching Terms of Service:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDocument();
  }, []);

  return (
    <>
      <LandingHeader />
      <main className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <FaSpinner className="animate-spin text-4xl text-primary" />
            </div>
          ) : error ? (
            <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
              <p className="text-red-800">{error}</p>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
              {/* Back to Consent Button - Only show if accessed from consent modal */}
              {fromConsent && (
                <div className="mb-6">
                  <button
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium"
                  >
                    <FaArrowLeft />
                    Back to Consent Form
                  </button>
                </div>
              )}
              
              <div className="flex items-center gap-3 mb-8">
                <FaFileContract className="text-3xl text-primary" />
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
                  {document?.title || 'Terms of Service'}
                </h1>
              </div>

              <div
                className="prose prose-lg max-w-none text-gray-700"
                dangerouslySetInnerHTML={{ __html: document?.content || 'Content will be available soon.' }}
              />
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}

export default TermsOfService;

